import { environment } from '@env/environment';

export const Constants: any = {
  CUSTOMER_INACTIVITY_TIME: 30000,
  Apps: {
    Agent: { name: 'Agent', slug: 'agent', defaultPath: '/agent/dashboard' },
    Supervisor: { name: 'Supervisor', slug: 'supervisor', defaultPath: '/supervisor/insight/dashboard' },
    Admin: { name: 'Admin', slug: 'admin', defaultPath: '/admin/user/list' },
    QA: { name: 'Quality Assurance', slug: 'qa', defaultPath: '/supervisor/insight/agent-call-evaluation/call-list' },
  },
  PAGING: {
    PAGE_SIZE: 20,
  },
  APIS: {
    TELEPHONY: {
      GET_TOKEN: `/token/getToken`,
      TWILIO_SETTINGS: `/twilio/getSettings`,
      GET_CONFERENCE: `/twilio/getConferenceInfo`,
      CONSULT: `/calloperations/consult`,
      CONFERENCE: `/calloperations/conference`,
      TOGGLE: `/calloperations/toggle`,
      ENDTHIRDPARTY: `/calloperations/endThirdParty`,
      HOLD: `/calloperations/hold`,
      ENDCALL: `/calls/complete`,
      WARM_TRANSFER: `/calloperations/warmtransfer`,
      COLD_TRANSFER: `/calloperations/coldtransfer`,
      QUEUED_CALLS: `/twilio/getQueueCalls`,
      MONITOR_CALL: `/calloperations/monitor`,
      FETCH_CALL: `/twilio/getCallInfo`,
      UPDATE_ACTIVITY: `/twilio/updateWorkerActivity`,
      GET_AVAILABLE_PHONE_NUMBERS: `/phone_number/available`,
      FORCE_DISPOSED: `/calls/force-disposed`,
      UPDATE_LEAD_STATUS: `/calls/updateLeadStatus`,
      IBEX_DIALER: {
        LOGIN: '/workers/ibex/login',
        LOGOUT: '/workers/ibex/logout',
        UPDATE_BREAK_STATUS: '/workers/ibex/updateBreakStatus',
        END_CALL: '/calloperations/endcall',
        LOGIN_STATUS: '/workers/ibex/agentLoginStatus',
        MANUAL_CALL: '/calloperations/manualcall',
        GET_QUEUED_CALLS: '/insights/queuedcalls',
        TRANSFER_CALL: `/calloperations/transfer`,
        INSIGHTS_LOGIN_USER: `/insights/loggedInUser`,
        CURRENT_STATUS: '/workers/ibex/agentCurrentStatus',
        ACTIVE_CALLS: `/insights/activecalls`,
      },
      UPDATE_STATUS: `/calloperations/status`,
      MARK_COMPLETE: `/calls/mark-complete`,
    },
    MESSENGER: {
      GET_TOKEN: `/token/getToken`,
      TWILIO_SETTINGS: `/messenger/twiml/getSettings`,
      GET_CONVERSATIONS: `/conversation`,
      GET_MESSAGES: `/message`,
      GET_CONVERSATION_BY_SID: `/conversation/getBySid`,
      ACCEPT_CHAT: `/conversation/acceptIncomingChat`,
      COMPLETE_CHAT: `/conversation/endChatByAgent`,
      GET_SETTINGS: `/campaign/getChatSettings`,
      GET_RATING: `/rating`,
      SHARE_CHAT: `/conversation/sendTranscriptHistoryOnEmail`,
      FETCH_AGENTS: `/user/getUsers`,
      FETCH_ONLINE_CHAT_AGENTS: `/user/getOnlineChatUsers`,
      HANDOVER_CHAT: `/conversation/transferChat`,
      CONVERSATION_HISTORY: `/conversation/getConversationHistoryById`,
      PENDING_REQUESTS: '/conversation/pendingRequests',
      HAS_PENDING_REQUESTS: '/conversation/hasPendingChats',
      CREATE_AGENT_CONVERSATION: '/conversation/initializeAgentChat',
      SEND_FB_QUICK_REPLY: '/facebook/sendQuickReply',
    },
    CAMPAIGN: {
      LIST: `/campaigns/list`,
      CREATE: `/campaigns`,
      UPDATE: `/campaigns/$(id)`,
      VIEW: `/campaigns/getbyid/$(id)`,
      CLONE: `/campaigns/clone`,
      PRIMARY_CAMPAIGN_SETTINGS: `/campaigns/settings`,
      META_DATA: `/campaigns/metadata`,
    },
    CONTACT: {
      GET: `/contacts`,
      UPDATE: `/contacts`,
    },
    CALL: {
      UPDATE: `/calls`,
      GET: `/calls`,
      ASSIGN: `/calls/assignedUser`,
      CALLBACK_COUNT: `/calls/agentCallbackCounts`,
    },
    TFN: {
      GET_GREETINGS: `/tfn/greeting`,
      LIST: `/tfn/list`,
      DETAIL: `/tfn/detail`,
      VIEW: `/tfn/number/$(tfn)`,
      CREATE: `/tfn`,
      UPDATE: `/tfn/$(id)`,
    },
    USER: {
      STATUS_LOG: `/userstatushistory`,
      TOTAL_BREAK_TIME: '/user/totalBreakTime',
    },
    BUNDLEDEALER: {
      GET_PGE_SEARCH_CUSTOMERS: `/bundleDealer/searchcustomerInfo`,
      GET_CUSTOMER_INFO: `/bundleDealer/customerInfo`,
      GET_PROVIDER_INFO: `/bundleDealer/getRandomProviders`,
      CREATE_SESSION: `/bundleDealer/createSession`,
      RESTORE_ORDER: `/bundleDealer/getOrderInfo`,
      PGE_CALL_DISPOSITION: `/bundleDealer/callDisposition`,
      SERVICEABLE_PROVIDERS: `/bundleDealer/getServiceableProviders`,
    },
    INTEGRATION: {
      HUBSPOT: {
        GET_CONTACT: `/hubspot/contact`,
      },
    },
    ALERT: {
      GET_AGENT_ALERT: '/alerts/agent',
      UPDATE_AGENT_ALERT_ACK: '/alerts/agent/acknowledge',
      GET_SUPERVISOR_ALERT: '/alerts/supervisor',
      GET_ALL_SUPERVISOR_ALERT: '/alerts/supervisor/all',
      GET_ALERT_DETAILS: '/alerts/get',
    },
  },
  CALL: {
    DIRECTION: {
      INBOUND: 0,
      OUTBOUND: 1,
    },
    DIRECTION_STRING: {
      INBOUND: 'Inbound',
      OUTBOUND: 'Outbound',
    },
  },
  STATUSES: {
    Lunch: {
      Name: 'Lunch',
      FriendlyName: 'Lunch',
      Key: 'LunchSid',
      Icon: 'fa-regular fa-mug-tea',
      class: 'lunch-icon-color',
      bgclass: 'lunch-status-dot-bg',
      ibex_status: '50',
    },
    Wait: {
      Name: 'Wait',
      FriendlyName: 'Wait',
      Key: 'WaitSid',
      Icon: 'fa-regular fa-clock-eight',
      class: 'wait-icon-color',
      bgclass: 'wait-status-dot-bg',
      ibex_status: 'Wait',
    },
    Break: {
      Name: 'Break',
      FriendlyName: 'Break',
      Key: 'BreakSid',
      Icon: 'fa-regular fa-mug-tea',
      class: 'break-icon-color',
      bgclass: 'break-status-dot-bg',
      ibex_status: '1',
    },
    ManualCall: {
      Name: 'Manual Call',
      FriendlyName: 'ManualCall',
      Key: 'ManualCallSid',
      Icon: 'fa-regular fa-headset icon-secondary',
      class: 'manualcall-icon-color',
      bgclass: 'manualcall-status-dot-bg',
      ibex_status: '20',
    },
    Callback: {
      Name: 'Callback',
      FriendlyName: 'Callback',
      Key: 'CallbackSid',
      Icon: 'fa-regular fa-phone-arrow-up-right icon-secondary',
      class: 'callback-icon-color',
      bgclass: 'callback-status-dot-bg',
      ibex_status: '70',
    },
    Busy: {
      Name: 'Busy',
      FriendlyName: 'Busy',
      Key: 'BusySid',
      Icon: '',
      ibex_status: '0',
      class: 'busy-icon-color',
      bgclass: 'busy-status-dot-bg',
    },
    Offline: {
      Name: 'Offline',
      FriendlyName: 'Offline',
      Key: 'OfflineSid',
      Icon: '',
      class: 'current-status--offline',
    },
    Wrap: {
      Name: 'Wrap',
      FriendlyName: 'Wrap',
      Key: '',
      Icon: '',
      ibex_status: '0',
      class: 'wrap-icon-color',
      bgclass: 'wrap-status-dot-bg',
    },
    Hold: {
      Name: 'Hold',
      FriendlyName: 'Hold',
      Key: '',
      Icon: '',
      ibex_status: '0',
      class: 'hold-icon-color',
      bgclass: 'hold-status-dot-bg',
    },
    Chat: {
      Name: 'Chat',
      FriendlyName: 'Chat',
      Key: 'ChatSid',
      Icon: 'fa-regular fa-comment-lines icon-secondary',
      class: 'chat-icon-color',
      bgclass: 'chat-status-dot-bg',
    },
    CoachingCounseling: {
      Name: 'Counseling',
      FriendlyName: 'CoachingCounseling',
      Key: 'CoachingCounselingSid',
      Icon: 'fa-regular fa-chalkboard-user icon-secondary',
      class: 'counseling-icon-color',
      bgclass: 'counseling-status-dot-bg',
      ibex_status: '15',
    },
    TeamMeeting: {
      Name: 'Team Meeting',
      FriendlyName: 'TeamMeeting',
      Key: 'TeamMeetingSid',
      Icon: 'fa-regular fa-handshake icon-tertiary',
      class: 'teammeeting-icon-color',
      bgclass: 'teammeeting-status-dot-bg',
      ibex_status: '36',
    },
    Training: {
      Name: 'Training',
      FriendlyName: 'Training',
      Key: 'TrainingSid',
      Icon: 'fa-regular fa-screen-users icon-tertiary',
      class: 'training-icon-color',
      bgclass: 'training-status-dot-bg',
      ibex_status: '41',
    },
    LoggedOut: {
      Name: 'LoggedOut',
      FriendlyName: 'LoggedOut',
      Key: 'OfflineSid',
      Icon: '',
      class: 'logout-icon-color',
      bgclass: 'logout-status-dot-bg',
    },
    LoggedIn: {
      Name: 'LoggedIn',
      FriendlyName: 'LoggedIn',
      Key: '',
      ibex_status: '90',
      Icon: '',
      class: 'loggedin-icon-color',
      bgclass: 'loggedin-status-dot-bg',
    },
    Away: {
      Name: 'Away',
      FriendlyName: 'Away',
      Key: 'OfflineSid',
      Icon: '',
      class: 'away-icon-color',
      bgclass: 'away-status-dot-bg',
    },
    Outbound: {
      Name: 'Outbound',
      FriendlyName: 'Outbound',
      Key: 'OutboundSid',
      Icon: 'fa-regular fa-screen-users icon-tertiary training',
      class: 'outbound-icon-color',
      bgclass: 'outbound-status-dot-bg',
      ibex_status: '2',
    },
  },
  STATUSES_LIST: [
    {
      Name: 'Lunch',
      FriendlyName: 'Lunch',
      Key: 'LunchSid',
      Icon: 'fa-regular fa-mug-tea',
      class: 'current-status--break',
      ibex_status: '50',
    },
    { Name: 'Wait', FriendlyName: 'Wait', Key: 'WaitSid', Icon: 'fa-regular fa-clock-eight wait', ibex_status: 'Wait' },
    { Name: 'Break', FriendlyName: 'Break', Key: 'BreakSid', Icon: 'fa-regular fa-mug-tea break', ibex_status: '1' },
    {
      Name: 'Manual Call',
      FriendlyName: 'ManualCall',
      Key: 'ManualCallSid',
      Icon: 'fa-regular fa-headset icon-secondary manualCall',
      ibex_status: '20',
    },
    {
      Name: 'Callback',
      FriendlyName: 'Callback',
      Key: 'CallbackSid',
      Icon: 'fa-regular fa-phone-arrow-up-right icon-secondary callback',
      ibex_status: '70',
    },
    { Name: 'Chat', FriendlyName: 'Chat', Key: 'ChatSid', Icon: 'fa-regular fa-comment-lines icon-secondary chat' },
    {
      Name: 'Counseling',
      FriendlyName: 'CoachingCounseling',
      Key: 'CoachingCounselingSid',
      Icon: 'fa-regular fa-chalkboard-user icon-secondary counseling',
      ibex_status: '15',
    },
    {
      Name: 'Team Meeting',
      FriendlyName: 'TeamMeeting',
      Key: 'TeamMeetingSid',
      Icon: 'fa-regular fa-handshake icon-tertiary teamMeeting',
      ibex_status: '36',
    },
    {
      Name: 'Training',
      FriendlyName: 'Training',
      Key: 'TrainingSid',
      Icon: 'fa-regular fa-screen-users icon-tertiary training',
      ibex_status: '41',
    },
    {
      Name: 'Outbound',
      FriendlyName: 'Outbound',
      Key: 'OutboundSid',
      Icon: 'fa-regular fa-megaphone',
    },
  ],
  GREETING: {
    CableCompany: 'ibex.',
    Subtitle: 'listen and be engaged - remember to get callers name up front and use it during your interactions?',
    Text: 'Thank you for calling DGS. My name is [_____], How may i help you today?',
  },
  PK_SKILLCODE: 'L18',
  PGESKILLCODE: 'K08,K09,K10,K11',
  PGESPANISHSKILLCODE: 'K09',
  FPL_NRG_SKILLCODE: 'K05,K04,K13',
  FPL_ENGLISH_SKILLCODE: 'K06',
  STAR_LINK_SKILLCODE: 'K02,K03',
  STAR_LINK2_SKILLCODE: 'K01,NC1',
  ZIPLY_SKILLCODE: 'K00',
  PORTMORE_DEFAULT_SPANISH_SKILLCODE: 'E11,E13,E14',
  PORTMORE_SKILLCODE: 'E01,E02,E03,E05,E06,E15,E20,E11,E13,E14',
  USH_SKILLCODE: 'E15,E16,E17,E18,K15,K16,K17,K18',
  PASTANDARDTFNs:
    '+18302183972,+18302183973,+18445396821,+18445404094,+18773102112,+18333664581,+18444859075,+18559383016,+18447193056,+18336527441',
  PASTANDARDCOMMERCIALTFNs:
    '+18302183974,+18302183982,+18302183986,+18302183987,+18302183988,+18302183979,+18778694220,+18559383469,+18559383379,+18559383379',
  PASTANDARDSKILLS: 'E17,E18',
  FEAddonMustSelect:
    '+18559383389,+18669874305,+18446883909,+18446883910,+18446883911,+18446883912,+18773751205,+18443574456,+18443547815,+18443595613,+18443595614,+18443724954,+18443724955,+18443724956,+18443724957,+18339491476,+18339491498,+18446471705,+18446475552,+18446475623,+18446475621,+18446784956,+18446784957,+18446784958,+18339500087,+18559682437',
  FEDirectCallTFNs: '+18559383389,+18443437251,+18443437254,+18443437506',
  DefaultsToWorkbenchTFNs: '+18559383389,+18443547794',
  FEAddonsToCheck:
    'FE Surge Pitched Accepted,FE Surge Pitched Declined,FE Surge - Unable to Pitch,FE Surge not Available,Sam’s – Pitched Accepted,Sam’s – Pitched Declined,Sam’s – Unable to Pitch',
  PKAddonsToCheck:
    'VIVINT NOT APPLICABLE,VIVINT PITCHED AND TRANSFERRED,VIVINT PITCHED AND DECLINED,ADT Not Applicable,ADT PITCHED AND LEAD GENERATED,ADT Pitched and Transferred,ADT Pitched and Declined',
  PKMsoConfrimationDropDown: 'CHARTER,TIME WARNER,BRIGHTHOUSE, SPECTRUM',
  ZIPLY_FINALIZED_DISPOSITIONS: ['Lead Generated'],
  ZIPLY_SHOW_OTHER_REASONS_DISPOSITIONS: ['Not Interested'],
  TIKTOK_SKILLCODE: 'TS2',
  PKCHAT_SKILLCODE: 'TS1,TS8,TS9',
  PKCHAT_TFNS: '',
  OUTBOUND_DIALER: {
    GET_LEAD: `/lead/get`,
    GET_CAMPAIGN_LEAD: `/calls/getLead`,
  },
  INTEGRATION: {
    HUBSPOT: {
      GET_METADATA: `/hubspot/metadata`,
    },
    SALEFORCE: {
      GET_METADATA: `/salesforce/metadata`,
    },
    TIKTOK: {
      GET_METADATA: `/tiktok/metadata`,
    },
  },
};

export const logicalOperators = ['AND', 'OR', 'NOT'];

export class FilterOperator {
  public constContains = 'CONTAINS';
  public constNotContains = "DOESN'T CONTAINS";
  public constEqual = 'EQUALS TO';
  public constStartWith = 'STARTS WITH';
  public constEndWith = 'ENDS WITH';
  public constBetween = 'NA';
  public constGreaterThan = '>';
  public constGreaterThanEqualTo = '>=';
  public constLessThan = '<';
  public constLessThanEqualTo = '<=';
  public constEqualTo = '=';
}
export const LEADSOURCE = {
  HUBSPOT: 'Hubspot',
  ZIPLY: 'Ziply',
  TIKTOK: 'TikTok',
};
export const EVENT_TYPES = {
  Provider: 'Provider',
  Integration: 'Integration',
  OutboundDialer: 'OutboundDialer',
  Reservation: 'Reservation',
  Call: 'Call',
};
export const EVENT_NAMES = {
  Accepted: 'accept',
  Disposed: 'dispose',
  Callback: 'Callback',
  Init: 'init',
  Metadata: 'metadata',
  Greeting: 'greeting',
  Started: 'started',
  LeadSet: 'leadset',
  ForceComplete: 'forcecomplete',
  FetchLead: 'fetchlead',
};

export const PAGINATION = {
  ChatTakeCount: 300,
};
